import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { LoadingStatus, LoadMoreButton, LoadMoreButtonType } from './partials/LoadMoreButton';
import { Modifier } from '../../../lib/bemUtils/Modifier';

type LoadMoreProps = PropsWithChildren<{
  loadMore?: LoadMoreButtonType;
  loadMoreStatus?: LoadMoreButtonType;
  loadMoreItems: () => void;
  loadingStatus?: LoadingStatus;
  ref?: React.RefObject<HTMLDivElement | null>;
  buttonContainerModifier?: Modifier<'no-border'>
}>;

export function LoadMore({
  loadMore,
  loadMoreStatus,
  loadMoreItems,
  loadingStatus,
  children,
  ref,
  buttonContainerModifier,
}: LoadMoreProps) {
  return (
    <div className={bem('load-more', loadMore ? 'scroll' : null)} ref={ref}>
      {children}
      {loadMore
        ? (
            <LoadMoreButton
              maxResultsSize={loadMore.maxResultsSize}
              fromResults={loadMoreStatus?.fromResults || 1}
              toResults={loadMoreStatus?.toResults || loadMore?.fromResults - 1}
              onClick={loadMoreItems}
              loadingStatus={loadingStatus}
              backToTop={!!(!loadMoreStatus && loadMore)}
              buttonContainerModifier={buttonContainerModifier}
            />
          )
        : null}
    </div>
  );
}
